import { List, ListItem } from "@chakra-ui/react";
import { LearnMore } from "./learn-more.component";

type MoreOptionsProps = {
   materials: string[];
};

export default function MoreOptions({ materials }: MoreOptionsProps) {
   return (
      <LearnMore>
         <List spacing={2} styleType="disc" pl="4">
            {materials.map((item, index) => (
               <ListItem key={index} fontSize="sm">
                  {item}
               </ListItem>
            ))}
         </List>
      </LearnMore>
   );
}
